import { Form, Space } from 'antd';
import { CSSProperties, PropsWithChildren, useMemo } from 'react';
import GrispiLabel, { GrispiLabelProps } from './GrispiLabel';

export interface GrispiInputContainerProps extends GrispiLabelProps {
    errorMessage?: string; // validation
    extra?: string;
    width?: CSSProperties['width'];
    noLabel?: boolean;
    alignment?: 'checkbox' | 'horizontal' | 'vertical';
    secondaryLabel?: string;
}

const GrispiInputContainer = ({
    actionButton,
    alignment = 'vertical',
    children,
    description,
    errorMessage,
    extra,
    fieldRequirement,
    label,
    noLabel,
    secondaryLabel,
    width = '100%'
}: PropsWithChildren<GrispiInputContainerProps>) => {
    const validateStatus = errorMessage ? 'error' : undefined;
    const helpText = !validateStatus ? extra : errorMessage;
    const isCheckboxAlignment = alignment === 'checkbox';
    const direction = isCheckboxAlignment ? 'horizontal' : alignment;
    const size = isCheckboxAlignment ? 10 : 2;

    const memoizedLabel = useMemo(
        () =>
            !noLabel && (
                <GrispiLabel
                    label={label}
                    description={description}
                    actionButton={actionButton}
                    fieldRequirement={fieldRequirement}
                />
            ),
        [label, description, actionButton, fieldRequirement, noLabel]
    );
    return (
        <Space direction={direction} size={size} style={{ width }}>
            {isCheckboxAlignment ? (
                <>
                    <Space align="center">
                        <Form.Item validateStatus={validateStatus} help={helpText} className="custom-field-item">
                            <GrispiLabel label={secondaryLabel} />
                        </Form.Item>
                        {children}
                        <Form.Item validateStatus={validateStatus} help={helpText} className="custom-field-item">
                            {memoizedLabel}
                        </Form.Item>
                    </Space>
                </>
            ) : (
                <>
                    {memoizedLabel}
                    <Form.Item validateStatus={validateStatus} help={helpText} className="custom-field-item">
                        {children}
                    </Form.Item>
                </>
            )}
        </Space>
    );
};

export default GrispiInputContainer;
